import React from "react";
import { IconButton } from "@mui/material";
import { MdClose } from "react-icons/md";
import { FeedbackBoxWrapper, FeedbackChip, FeedbackDescription, FeedbackTitle, RequestAssistanceContainer, ZoomButton } from "./FAQSearch.style";

const AssistantFeedbackBox = ({
  isMobile,
  showFaqQR,
  setChatInput,
  setPendingFeedback,
  setFeedbackMode,
  setActiveFeedbackIndex
}) => {
  const feedbackOptions = ["Answer not useful", "Answer link not working", "Others:"];
  const handleAddToFaqList = () => {
    const confirm = window.confirm('Proceed to add your question to the FAQ List?');
    if (confirm) {
      window.open('https://libfaq.nus.edu.sg/#s-la-askform-section-145', '_blank');
    }
  };
  const handleCancel = () => {
    setFeedbackMode(false);
    setActiveFeedbackIndex(null);
    setPendingFeedback({ messageId: null, feedbackType: null, defaultText: '', message_query: '', message_response: '' });
    setChatInput('');
  };

  return (
    <FeedbackBoxWrapper>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
        <FeedbackTitle variant="subtitle2" >
            What went wrong? (type below, no personal information)
        </FeedbackTitle>
        <IconButton 
          size="small" 
          onClick={handleCancel}
          style={{ padding: '4px' }}
          aria-label="Cancel feedback"
        >
          <MdClose />
        </IconButton>
      </div>
      <RequestAssistanceContainer>
        <div>
        {feedbackOptions.map((label) => (
          <FeedbackChip
            key={label}
            label={label}
            variant="outlined"                      
            onClick={() => {
              const input = label === "Tell us more" ? "Explanation: " : label;
              setChatInput(input); // sets input field
              setPendingFeedback((prev) => ({
                ...prev,
                defaultText: input,
              }));
            }}
          />
        ))}
        </div>
        </RequestAssistanceContainer>

        {isMobile &&
        <>
          <FeedbackTitle variant="subtitle2" > 
            Need more help?
          </FeedbackTitle>

          <ZoomButton
            active={showFaqQR}
            onClick={() => {
              handleAddToFaqList();
            }}
          >
            <FeedbackDescription variant="caption" > Add to FAQ List </FeedbackDescription>
          </ZoomButton>
          </>
        }
    </FeedbackBoxWrapper>
  );
};

export default AssistantFeedbackBox;
